//import DisableRestaurantChangedBase from '../Bases/DisableRestaurantChangedBase.js'
export default {
    name: 'ItemBaseForm',
    data() {
        return {
            itemAction: '',
            item: {
                itemId: '',
                itemName: '',
                description: '',
                originalPrice: '',
                taxId: '',
                categoryId: '',
                image: [],
                imageUrl: ''
            },
            image: [],
            imagesForUpload: []
        }
    },
    methods: {
        setAction(actionParam) {
            this.itemAction = actionParam;
        },
        clearItem() {
            this.$router.push('/items'); 
        },
        async handleBtnSave() {
            //Set loading
            this.$store.commit('loading/setLoadingState', true);
            let formData = new FormData();
            formData.append('file', this.imagesForUpload);
            await this.$store.dispatch(this.itemAction, {'item' : this.item, 'image':formData});
            this.clearItem();
        },
        handleBtnCancel() {
            this.clearItem();
        }
    }
}